import { render, staticRenderFns } from "./EmbeddedYoutubeVideo.vue?vue&type=template&id=e53fbc20&"
import script from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports